import * as React from "react";
import { Widget, mk_widget, any, AsyncState } from "widgets-for-react";
import { styleguideChapter, styleguideSection, styleguidePart, styleguideExample} from "../helpers"
import { dummyButton } from "../dummyContent";
import { ctaBlockClasses } from "../../components/public_site/blocks/style.mod";
import { CMSState } from "../../components/cms/blocks/types.gen";
import { ImageStackBlock, ImageStackBlockStyle } from "../../components/public_site/blocks/custom_blocks/widgets/imageStackBlock";
import { PublicSiteState, HeaderState } from "../../components/public_site.main.mod";
import { WordPress } from "../../components/wordpress/wordpress_api";
import { placeholderImage } from "../../components/public_site/utils/extra_images.mod";
import { FeaturedContentBlock } from "../../components/public_site/blocks/custom_blocks/widgets/featuredContentBlock";
import { FactsAndFiguresBlock } from "../../components/public_site/blocks/custom_blocks/widgets/factsAndFiguresBlock";
import { QuoteBlock } from "../../components/public_site/blocks/custom_blocks/widgets/quoteBlock";
import { ImageGalleryBlock } from "../../components/public_site/blocks/custom_blocks/widgets/imageGalleryBlock";
import { header } from "../../components/public_site/templates/header.mod";
import { TextBlock } from "../../components/public_site/blocks/custom_blocks/widgets/textBlock";
import { MediaBlock } from "../../components/public_site/blocks/custom_blocks/widgets/mediaBlock";
import { CtaBlock } from "../../components/public_site/blocks/custom_blocks/widgets/ctaBlock";
import { GridBlock } from "../../components/public_site/blocks/custom_blocks/widgets/gridBlock.mod";
import { LinkBlock } from "../../components/public_site/blocks/custom_blocks/widgets/linkBlock";
import { ImageTextBlock } from "../../components/public_site/blocks/custom_blocks/widgets/imageTextBlock.mod";
import { HeaderBlock, primaryHeaderBlock, secondaryHeaderBlock } from "../../components/public_site/blocks/custom_blocks/widgets/headerBlock.mod";
import { footer } from "../../components/public_site/templates/footer.mod";
import { PublicSiteCustomRoutes } from "../../components/public_site/custom_pages/types.mod";
import { AppState } from "../../components/cms/state/types.gen";

export const styleguideComponents: Widget<never> = mk_widget({
         run: _ =>
           any()([
             styleguideChapter({type: "components", slug: "components", title: "Site header"})(
               styleguideSection({type: "components", slug: "site-header", title: ""})(
                 any()([
                   styleguidePart({})(
                     styleguideExample({showExampleLabel: true, isFullScreen: false})(
                      header({
                      } as HeaderState, {

                      } as AsyncState<WordPress.OptionsResponse>)
                     )

                   ),

                   styleguidePart({})(
                     styleguideExample({showExampleLabel: true, isFullScreen: false})(
                      header({
                        lang: 'open'
                      } as HeaderState, {
                        // kind: 'loaded',
                        // value: {
                        //   acf: {

                        //   }
                        // }
                      } as AsyncState<WordPress.OptionsResponse>)
                     )

                   ),
                 ])
               )
             ), // end site header

             styleguideChapter({type: "components", slug: "components", title: "Footer"})(
               styleguideSection({type: "components", slug: "footer", title: ""})(
                 any()([
                   styleguidePart({title: ""})(
                     styleguideExample({showExampleLabel: true, isFullScreen: false, description: ""})(
                      footer({} as AppState<PublicSiteState, PublicSiteCustomRoutes>)
                     )
                   )
                 ])
               )
             ), // end section footer

             styleguideChapter({type: "components", slug: "components", title: "Page header"})(
               styleguideSection({type: "components", slug: "page-header", title: ""})(
                 any()([
                   styleguidePart({title: "Hero - Primary"})(
                    any()([
                      styleguideExample({showExampleLabel: true, isFullScreen: false, description: ""})(
                        mk_widget({
                          run: _ => (
                           <header className="hero hero--primary hero--has-image">
                             <div className="hero__inner">
                               <div className="hero__content container--m grid--gutter">
                                 <h1 className="hero__title typo--3xl">Hallo, wij zijn Dubbeldam</h1>
                                 <div className="hero__intro">
                                   <div className="typo--xs text--styled">
                                     <p>Uw partner die ervoor zorgt dat uw voertuigen inzetbaar blijven. Wilt u een carrosserie laten bouwen of een voertuig laten bewerken, keuren of herstellen tot nieuwstaat? Met 208 man staan we voor u klaar.</p>
                                   </div>
                                   <div className="hero__buttons">
                                     <a className="button button--secondary" href="/sample-page/">
                                       <span className="button__text">Show more</span>
                                     </a>
                                     <a className="button button--secondary" href="/sample-page/">
                                       <span className="button__text">Go to page</span>
                                     </a>
                                   </div>
                                 </div>
                               </div>
                               <div className="hero__visual"
                                 style={{
                                   backgroundImage: 'url("https://images.unsplash.com/photo-1492168732976-2676c584c675?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1100&q=80")'
                                 }}
                               ></div>
                             </div>
                           </header>
                          )
                         })
                       ),
                     styleguideExample({showExampleLabel: true, isFullScreen: false, description: ""})(
                       primaryHeaderBlock({
                        blockName: 'vidda/header',
                        header_type: "header one",
                        title: "Hallo, wij zijn Dubbeldam",
                        intro: "Uw partner die ervoor zorgt dat uw voertuigen inzetbaar blijven. Wilt u een carrosserie laten bouwen of een voertuig laten bewerken, keuren of herstellen tot nieuwstaat? Met 208 man staan we voor u klaar",
                        primary_button: {
                          text: 'Go to page to read more',
                          url: ''
                        }
                       })({} as CMSState<{}, {}, never>)({} as PublicSiteState)
                      )
                    ])
                  ), // end section hero primary

                  styleguidePart({title: "Hero - Secondary"})(
                   styleguideExample({showExampleLabel: true, isFullScreen: false, description: ""})(
                    secondaryHeaderBlock({
                     blockName: 'vidda/header',
                     header_type: "header two",
                     title: "Hallo, wij zijn Dubbeldam",
                     intro: "Uw partner die ervoor zorgt dat uw voertuigen inzetbaar blijven. Wilt u een carrosserie laten bouwen of een voertuig laten bewerken, keuren of herstellen tot nieuwstaat? Met 208 man staan we voor u klaar",
                     primary_button: {
                       text: 'Go to page to read more',
                       url: ''
                     }
                    })({} as CMSState<{}, {}, never>)({} as PublicSiteState)
                   )
                 )  // end section hero secondary
                ])
              )
            ), // end Heroes 

             styleguideChapter({type: "components", slug: "components", title: "Text block"})(
               styleguideSection({type: "components", slug: "text-block", title: ""})(
                 any()([
                 styleguidePart({title: ""})(
                   styleguideExample({showExampleLabel: false, isFullScreen: false, description: ""})(
                     TextBlock({
                      primary_button: {
                        text: "Inceptos Amet Nullam",
                        url: ""
                      },
                      secondary_button:{
                        text: "Ridiculus Risus Amet Fringilla",
                        url: ""
                      },
                      has_show_more: false,
                      title: 'Dolor Vehicula Nullam',
                      text: "<p>Donec id elit non mi porta gravida at eget metus. Donec sed odio dui. Donec id elit non mi porta gravida at eget metus. Donec sed odio dui.</p><h3>H3 Ullamcorper Dolor Ligula</h3><p>Integer posuere erat a ante venenatis dapibus posuere velit aliquet. <a>Etiam porta sem malesuada magna mollis euismod.</a> Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Aenean lacinia bibendum nulla sed consectetur.</p><blockquote class='wp-block-quote'><p>Maecenas sed diam eget risus varius blandit sit amet non magna. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Etiam porta sem malesuada magna mollis euismod.</p><cite>citationnnnnnnn name stuff</cite></blockquote><h4>H4 Condimentum Magna Fermentum Egestas Vestibulum</h4><ul><li>Sed posuere consectetur est at lobortis. Donec ullamcorper nulla non metus auctor fringilla.</li><li>Tristique Lorem<ol><li>Donec ullamcorper nulla non metus auctor fringilla. </li><li>Donec id elit non mi porta gravida at eget metus. </li><li>Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Sed posuere consectetur est at lobortis.</li></ol></li><li>Aenean lacinia bibendum nulla sed consectetur. Vestibulum id ligula porta felis euismod semper.<ul><li>Tristique Lorem</li></ul><ul><li>Donec ullamcorper nulla non metus auctor fringilla. Donec id elit non mi porta gravida at eget metus. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Sed posuere consectetur est at lobortis.</li></ul></li><li>Aenean lacinia bibendum nulla sed consectetur. Vestibulum id ligula porta felis euismod semper.</li></ul><ol><li>Aenean lacinia bibendum nulla sed consectetur. Vestibulum id ligula porta felis euismod semper.</li><li> Vestibulum id ligula<ol><li>Sed posuere consectetur est at lobortis. Donec ollamcorper nulla non metus auctor fringilla.</li><li>Tristique Lorem</li><li>Aenean lacinia bibendum nulla sed consectetur. Vestibulum id ligula porta felis euismod semper.</li></ol></li><li>Aenean lacinia bibendum nulla sed consectetur. Vestibulum id ligula porta felis euismod semper.<ul><li>Tristique Lorem</li><li>Donec ullamcorper nulla non metus auctor fringilla. Donec id elit non mi porta gravida at eget metus. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Sed posuere consectetur est at lobortis.</li></ul></li><li>Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.</li></ol><blockquote class='wp-block-quote'><p>Maecenas sed diam eget risus varius blandit sit amet non magna. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Etiam porta sem malesuada magna mollis euismod.</p><cite>citationnnnnnnn name stuff</cite></blockquote>"
                     })({} as CMSState<{}, {}, never>)
                   )
                  ), // end part text
                ])
              )
            ), // end section text block

            styleguideChapter({type: "components", slug: "components", title: "Image + text blocks"})(
              styleguideSection({type: "components", slug: "image-text-blocks", title: ""})(
                any()([
                  styleguidePart({title: "Image on left side"})(
                    any()([
                      styleguideExample({showExampleLabel: false, isFullScreen: false, description: ""})(
                        ImageTextBlock({
                          background_color: "dark",
                          blockName: 'vidda/image-text',
                          image: placeholderImage(''),
                          image_position: "left",
                          intro: "Sed posuere consectetur est at lobortis. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.",
                          title: 'Mattis Parturient Sollicitudin',
                          primary_button: {
                            text: 'Neem contact op',
                            url: ''
                          },
                          secondary_button: {
                            text: 'Neem contact op',
                            url: ''
                          }
                        })({} as CMSState<{}, {}, never>)({} as PublicSiteState)
                      ),

                      styleguideExample({showExampleLabel: false, isFullScreen: false, description: ''})(
                        ImageTextBlock({
                          background_color: "light",
                          blockName: 'vidda/image-text',
                          image: placeholderImage(''),
                          image_position: "left",
                          intro: "Sed posuere consectetur est at lobortis. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.",
                          title: 'Mattis Parturient Sollicitudin',
                          primary_button: {
                            text: 'Neem contact op',
                            url: ''
                          },
                          secondary_button: {
                            text: 'Neem contact op',
                            url: ''
                          }
                        })({} as CMSState<{}, {}, never>)({} as PublicSiteState)
                      ),
                    ])
                  ),

                  styleguidePart({title: "Image on right side"})(
                    any()([
                      styleguideExample({showExampleLabel: false, isFullScreen: false, description: ""})(
                        ImageTextBlock({
                          background_color: "dark",
                          blockName: 'vidda/image-text',
                          image: placeholderImage(''),
                          image_position: "right",
                          intro: "Sed posuere consectetur est at lobortis. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.",
                          title: 'Mattis Parturient Sollicitudin',
                          primary_button: {
                            text: 'Neem contact op',
                            url: ''
                          },
                          secondary_button: {
                            text: 'Neem contact op',
                            url: ''
                          }
                        })({} as CMSState<{}, {}, never>)({} as PublicSiteState)
                      ),

                      styleguideExample({showExampleLabel: false, isFullScreen: false, description: ''})(
                        ImageTextBlock({
                          background_color: "light",
                          blockName: 'vidda/image-text',
                          image: placeholderImage(''),
                          image_position: "right",
                          intro: "Sed posuere consectetur est at lobortis. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.",
                          title: 'Mattis Parturient Sollicitudin',
                          primary_button: {
                            text: 'Neem contact op',
                            url: ''
                          },
                          secondary_button: {
                            text: 'Neem contact op',
                            url: ''
                          }
                        })({} as CMSState<{}, {}, never>)({} as PublicSiteState)
                      ),
                    ])
                  )
                ])
              )
            ), 

            styleguideChapter({type: "components", slug: "components", title: "Download list block"})(
              styleguideSection({type: "components", slug: "download-list-block", title: ""})(
                any()([
                  styleguidePart({title: ""})(
                    styleguideExample({showExampleLabel: false, isFullScreen: false, description: ""})(
                      mk_widget({
                        run: _ => (
                          <section className="block block--download-list container--s">
                            <div className="block__inner grid--block">
                              <header className="block__header">
                                <h2 className="block__title typo--xl">Block title Porta Sem Cursus Tortor Tellus</h2>
                                <p className="block__intro">
                                Maecenas faucibus mollis interdum. Vestibulum id ligula porta felis euismod semper. Donec ullamcorper nulla non metus auctor fringilla. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Maecenas faucibus mollis interdum. Vestibulum id ligula porta felis euismod semper.
                                </p>
                              </header>
                              <div className="block__content">
                                <ul className="block__list list-iconed list-iconed--download">
                                  <li>
                                    <a className="typo--s">Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</a>
                                  </li>
                                  <li>
                                    <a className="typo--s">Mollis Venenatis Purus</a>
                                  </li>
                                  <li>
                                    <a className="typo--s">Sed posuere consectetur est at lobortis. Maecenas faucibus mollis interdum.</a>
                                  </li>
                                </ul>
                              </div>
                              <footer className="block__footer">
                                <a className="button button--primary">Show more</a>
                                <a className="link link--primary">Read more</a>
                              </footer>
                            </div>
                          </section>
                        )
                      })
                      // LinkBlock({
                      //   title:'Cursus Pharetra Risus Amet Tortor',
                      //   intro: "Nulla vitae elit libero, a pharetra augue. Donec ullamcorper nulla non metus auctor fringilla. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
                      //   index: 12,
                      //   items: [
                      //     {
                      //       is_link_external: false,
                      //       url: '',
                      //       title: "Maecenas sed diam eget risus varius blandit sit amet non magna. Etiam porta sem malesuada magna mollis euismod.",
                            
                      //     },
                      //     {
                      //       is_link_external: false,
                      //       url: '',
                      //       title: "Aenean Sit Nullam Malesuada",
                            
                      //     },
                      //     {
                      //       is_link_external: false,
                      //       url: '',
                      //       title: "Inceptos Elit Aenean Ridiculus",
                            
                      //     }
                      //   ],
                      //   useSVGIcons: false
                      // })({} as CMSState<{}, {}, never>)
                    )
                  )
                ])
              )
            ), // end list link block

            styleguideChapter({type: "components", slug: "components", title: "Media block"})(
              styleguideSection({type: "components", slug: "media-block", title: ""})(
                any()([
                  styleguidePart({title: "Image"})(
                    styleguideExample({showExampleLabel: false, isFullScreen: false, description: ""})(
                     MediaBlock({
                       caption: 'Donec id elit non mi porta gravida at eget metus. Vestibulum id ligula porta felis euismod semper.',
                      //  useCookieBar: true,
                       type: 'image',
                       image: placeholderImage('')
                     })({} as CMSState<{}, {}, never>)
                    )
                  )
                ])
              )
            ), // end section media block

            styleguideChapter({type: "components", slug: "components", title: "Call To Action blocks"})(
              styleguideSection({type: "components", slug: "cta-blocks", title: ""})(
                 styleguidePart({title: ""})(
                   styleguideExample({showExampleLabel: true, isFullScreen: false, description: ""})(
                     CtaBlock({
                       blockName: 'vidda/cta',
                       title: 'Heeft u een uitdagend vervoersprobleem? Wij helpen u graag.',
                       intro: 'Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Nullam id dolor id nibh ultricies vehicula ut id elit. Sed posuere consectetur est at lobortis.',
                       primary_button: {
                         text: 'Neem contact op',
                         url: ''
                       },
                       secondary_button: {
                         text: 'Neem contact op',
                         url: ''
                       }
                     })({} as CMSState<{}, {}, never>)
                   )
                 ) 
              )
            ), // end section CTA

             styleguideChapter({type: "components", slug: "components", title: "Quote block"})(
               styleguideSection({type: "components", slug: "quote-block", title: ""})(
                  styleguidePart({title: "Without image"})(
                    styleguideExample({showExampleLabel: false, isFullScreen: false, description: ""})(
                      QuoteBlock({
                        index: 0,
                        text: "Wat ik mooi vind, is dat we ons bezighouden met de hele keten, letterlijk en figuurlijk van gras tot glas. We kunnen en willen op veel plekken het verschil maken.",
                        author: 'Roel van Neerbos',
                        company: 'President Dubbeldam',
                        primary_button: {
                          is_link_external: false,
                          kind: 'link',
                          target: '_blank',
                          url: '',
                          title: "Read me"
                        },
                        secondary_button: {
                          is_link_external: false,
                          kind: 'link',
                          target: '_blank',
                          url: '',
                          title: "Read me"
                        }
                      })({} as CMSState<{}, {}, never>)
                    )
                  ),
               )
             ),

             styleguideChapter({type: "components", slug: "components", title: "Featured content block"})(
               styleguideSection({type: "components", slug: "featured-content-block", title: ""})(
                 any()([
                   styleguidePart({title: "Image on left side"})(
                     any()([
                       styleguideExample({showExampleLabel: false, isFullScreen: false, description: ""})(
                         FeaturedContentBlock({
                           blockName: "vidda/featured-content",
                           title: "Porta Mattis Tellus Vestibulum Consectetur",
                           intro:
                             "Everyday I work with wonderful animals to create a fantastic product. Looking ahead we feel confident we can continue to innovate.",
                           button: {
                             text: "Read more",
                             url: "/"
                           },
                           image_position: "left",
                           image: placeholderImage("Donec ullamcorper nulla non metus auctor fringilla")
                         })({} as CMSState<{}, {}, never>)({} as PublicSiteState)
                       ), // end block with left image
                       styleguideExample({showExampleLabel: false, isFullScreen: false, description: ""})(
                         FeaturedContentBlock({
                           blockName: "vidda/featured-content",
                           title: "Consectetur Ridiculus Commodo",
                           intro:
                             "Nullam quis risus eget urna mollis ornare vel eu leo. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Curabitur blandit tempus porttitor. Vestibulum id ligula porta felis euismod semper. Nullam quis risus eget urna mollis ornare vel eu leo.",
                           button: {
                             text: "Read more",
                             url: ""
                           },
                           image_position: "right",
                           image: placeholderImage("Donec ullamcorper nulla non metus auctor fringilla")
                         })({} as CMSState<{}, {}, never>)({} as PublicSiteState)
                       )
                     ])
                   )
                 ])
               )
             ), // end featured content block

            //  styleguideChapter({type: "components", slug: "components", title: "Image + text blocks"})(
            //    styleguideSection({type: "components", slug: "image-text-blocks", title: ""})(
            //      any()([
            //        styleguidePart({title: "Image on left side"})(
            //          styleguideExample({showExampleLabel: false, isFullScreen: false, description: ""})(
            //            mk_widget({
            //              run: _ => (
            //                <section className="block block--image-text block--image-left">
            //                  <div className="block__inner container--2xl">
            //                    <div className="block__content">
            //                      <h2 className="block__title typo--3xl">Block title Porta Sem Cursus Tortor Tellus</h2>
            //                      <p className="block__intro">
            //                        Everyday I work with wonderful animals to create a fantastic product. Looking ahead
            //                        we feel confident we can continue to innovate.
            //                      </p>
            //                      <footer className="block__footer">
            //                        <a className="button button--primary">Show more</a>
            //                        <a className="button button--secondary">Read more</a>
            //                      </footer>
            //                    </div>
            //                    <div className="block__visual">
            //                      <img width="432" src="https://via.placeholder.com/800x800" alt="Placeholder image" />
            //                    </div>
            //                  </div>
            //                </section>
            //              )
            //            })
            //          )
            //        ),

            //        styleguidePart({title: "Image on right side"})(
            //          styleguideExample({showExampleLabel: false, isFullScreen: false, description: ""})(
            //            mk_widget({
            //              run: _ => (
            //                <section className="block block--image-text block--image-right">
            //                  <div className="block__inner container--2xl grid--spacing">
            //                    <div className="block__content">
            //                      <h2 className="block__title typo--3xl">Block title Porta Sem Cursus Tortor Tellus</h2>
            //                      <p className="block__intro">
            //                        Everyday I work with wonderful animals to create a fantastic product. Looking ahead
            //                        we feel confident we can continue to innovate.
            //                      </p>
            //                      <footer className="block__footer">
            //                        <a className="button button--primary">Show more</a>
            //                        <a className="button button--secondary">Read more</a>
            //                      </footer>
            //                    </div>
            //                    <div className="block__visual">
            //                      <img width="432" src="https://via.placeholder.com/800x800" alt="Placeholder image" />
            //                    </div>
            //                  </div>
            //                </section>
            //              )
            //            })
            //          )
            //        )
            //      ])
            //    )
            //  ), // end image + text block

             styleguideChapter({type: "components", slug: "components", title: "Grid blocks"})(
               styleguideSection({type: "components", slug: "grid-blocks", title: "Grid blocks"})(
                 any()([
                   styleguidePart({title: "Without image"})(
                     styleguideExample({showExampleLabel: false, isFullScreen: false, description: "", extraClasses: ' page'})(
                       GridBlock({
                        blockName: 'vidda/grid',
                        title: 'Ullamcorper Quam Aenean Euismod',
                        intro: 'Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Integer posuere erat a ante venenatis dapibus posuere velit aliquet.',
                        primary_button: {
                          text: 'Button of the block',
                          url: ''
                        },
                        secondary_button: {
                          text: 'Button of the block',
                          url: ''
                        },
                        blocks: [
                          {
                            title: 'Cursus Aenean Tortor',
                            intro: 'Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.',
                            link: {
                              is_link_external: false,
                              kind: 'link',
                              target: '_blank',
                              url: '',
                              title: "Read me"
                            }
                          },
                          {
                            title: 'Ligula Vestibulum Euismod Ridiculus Consectetur',
                            intro: 'Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.',
                          },
                          {
                            title: 'Cursus Aenean Tortor Cursus Aenean Tortor Cursus Aenean Tortor',
                            intro: 'Praesent commodo cursus magna, vel scelerisque.',
                            link: {
                              is_link_external: false,
                              kind: 'link',
                              target: '_blank',
                              url: '',
                              title: "Amet Justo Fusce Tortor Vestibulum"
                            }
                          },
                          {
                            title: 'Ligula Vestibulum Euismod Ridiculus Consectetur',
                            intro: 'Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.',
                          },
                          {
                            title: 'Cursus Aenean Tortor Cursus Aenean Tortor Cursus Aenean Tortor',
                            intro: 'Praesent commodo cursus magna, vel scelerisque.',
                            link: {
                              is_link_external: false,
                              kind: 'link',
                              target: '_blank',
                              url: '',
                              title: "Amet Justo Fusce Tortor Vestibulum"
                            }
                          },
                        ]
                       })({} as CMSState<{}, {}, never>)({} as PublicSiteState)
                     )
                   ),

                   styleguidePart({title: "With image"})(
                     styleguideExample({showExampleLabel: false, isFullScreen: false, description: "", extraClasses: ' page'})(
                      GridBlock({
                        blockName: 'vidda/grid',
                        title: 'Ullamcorper Quam Aenean Euismod',
                        intro: 'Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Integer posuere erat a ante venenatis dapibus posuere velit aliquet.',
                        primary_button: {
                          text: 'Button of the block',
                          url: ''
                        },
                        secondary_button: {
                          text: 'Button of the block',
                          url: ''
                        },
                        blocks: [
                          {
                            title: 'Cursus Aenean Tortor',
                            intro: 'Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.',
                            link: {
                              is_link_external: false,
                              kind: 'link',
                              target: '_blank',
                              url: '',
                              title: "Read me"
                            },
                            image: placeholderImage(''), 
                          },
                          {
                            image: placeholderImage(''),
                            title: 'Ligula Vestibulum Euismod Ridiculus Consectetur',
                            intro: 'Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.',
                          },
                          {
                            title: 'Cursus Aenean Tortor Cursus Aenean Tortor Cursus Aenean Tortor',
                            intro: 'Praesent commodo cursus magna, vel scelerisque.',
                            link: {
                              is_link_external: false,
                              kind: 'link',
                              target: '_blank',
                              url: '',
                              title: "Amet Justo Fusce Tortor Vestibulum"
                            },
                            image: placeholderImage(''),
                          },
                          {
                            image: placeholderImage(''),
                            title: 'Ligula Vestibulum Euismod Ridiculus Consectetur',
                            intro: 'Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.',
                          },
                          {
                            image: placeholderImage(''),
                            title: 'Cursus Aenean Tortor Cursus Aenean Tortor Cursus Aenean Tortor',
                            intro: 'Praesent commodo cursus magna, vel scelerisque.',
                            link: {
                              is_link_external: false,
                              kind: 'link',
                              target: '_blank',
                              url: '',
                              title: "Amet Justo Fusce Tortor Vestibulum"
                            }
                          },
                        ]
                       })({} as CMSState<{}, {}, never>)({} as PublicSiteState)
                     ),
                   ),


                   styleguidePart({title: "Overview pages"})(
                    styleguideExample({showExampleLabel: false, isFullScreen: false, description: "", extraClasses: ' page--overview'})(
                     GridBlock({
                       blockName: 'vidda/grid',
                       title: 'Ullamcorper Quam Aenean Euismod',
                       intro: 'Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Integer posuere erat a ante venenatis dapibus posuere velit aliquet.',
                       primary_button: {
                         text: 'Button of the block',
                         url: ''
                       },
                       secondary_button: {
                         text: 'Button of the block',
                         url: ''
                       },
                       blocks: [
                         {
                           title: 'Cursus Aenean Tortor',
                           intro: 'Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.',
                           link: {
                             is_link_external: false,
                             kind: 'link',
                             target: '_blank',
                             url: '',
                             title: "Read me"
                           },
                           image: placeholderImage(''), 
                         },
                         {
                           image: placeholderImage(''),
                           title: 'Ligula Vestibulum Euismod Ridiculus Consectetur',
                           intro: 'Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.',
                         },
                         {
                           title: 'Cursus Aenean Tortor Cursus Aenean Tortor Cursus Aenean Tortor',
                           intro: 'Praesent commodo cursus magna, vel scelerisque.',
                           link: {
                             is_link_external: false,
                             kind: 'link',
                             target: '_blank',
                             url: '',
                             title: "Amet Justo Fusce Tortor Vestibulum"
                           },
                           image: placeholderImage(''),
                         },
                         {
                           image: placeholderImage(''),
                           title: 'Ligula Vestibulum Euismod Ridiculus Consectetur',
                           intro: 'Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.',
                         },
                         {
                           image: placeholderImage(''),
                           title: 'Cursus Aenean Tortor Cursus Aenean Tortor Cursus Aenean Tortor',
                           intro: 'Praesent commodo cursus magna, vel scelerisque.',
                           link: {
                             is_link_external: false,
                             kind: 'link',
                             target: '_blank',
                             url: '',
                             title: "Amet Justo Fusce Tortor Vestibulum"
                           }
                         },
                       ]
                      })({} as CMSState<{}, {}, never>)({} as PublicSiteState)
                    ),
                  )
                 ])
               )
             ), // end grid block

             styleguideChapter({type: "components", slug: "components", title: "Image gallery"})(
              styleguideSection({type: "components", slug: "gallery-block", title: ""})(
                styleguidePart({title: "Image gallery"})(
                  styleguideExample({showExampleLabel: false, isFullScreen: false, description: ""})(
                   ImageGalleryBlock({
                     blockName: 'vidda/gallery',
                     title: 'Justo Fermentum Ipsum',
                     intro: 'Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit.',
                     items: [
                       {
                         image: placeholderImage('Nullam id dolor id nibh ultricies vehicula ut id elit.'),
                         caption: 'Maecenas faucibus mollis interdum'
                       },
                       {
                         image: placeholderImage(''),
                         caption: 'Nullam quis risus eget urna mollis ornare vel eu leo'
                       },
                       {
                         image: placeholderImage('Donec ullamcorper nulla non metus auctor fringilla'),
                         caption: 'Ridiculus Tristique Ligula Fringilla'
                       },
                       {
                         image: placeholderImage('Nullam id dolor id nibh ultricies vehicula ut id elit'),
                         caption: 'Cras mattis consectetur purus sit amet fermentum. Maecenas sed diam eget risus varius blandit sit amet non magna'
                       },
                       {
                        image: placeholderImage('Nullam id dolor id nibh ultricies vehicula ut id elit'),
                        caption: 'Cras mattis consectetur purus sit amet fermentum. Maecenas sed diam eget risus varius blandit sit amet non magna'
                      },
                      {
                        image: placeholderImage('Nullam id dolor id nibh ultricies vehicula ut id elit'),
                        caption: 'Cras mattis consectetur purus sit amet fermentum. Maecenas sed diam eget risus varius blandit sit amet non magna'
                      }
                     ]
                   }, { style: {} }
                   )({} as CMSState<{}, {}, never>)({} as PublicSiteState)
                  )
                ) // end part image gallery
              )
            ) // end section image gallery

           ]).run(_)
       });

